export default __webpack_public_path__ + "static/how_it_works_step_2_desktop_tablet-54db1f0a223193b06b499067e3d5006e.webp";